import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useFetchImages } from '../../../../hooks/useFetchImages';
import { useSearchQuery } from '../../../../hooks/useSearchQuery';
import getFreepikImages from '../../../../utils/api-images/getFreepikImages';
import getUrlImage from '../../../../utils/api-images/getUrlImage';
import LoadingSpinner from './Partials/LoadingSpinner';
import ImagesContainer from './Partials/ImagesContainer';
import Image from './Partials/Image';
import DescriptionSection from './Partials/DescriptionSection';

const Freepik = ({ setAppImage }) => {
  const [query, handleInputQuery] = useSearchQuery();
  const [detail, setDetail] = useState(null);
  const [{ images, loading }, more] = useFetchImages(query, getFreepikImages);

  const handleSelect = (img) => {
    setDetail({
      name: img.author?.name || 'Unknown',
      authorPage: img.url,
      description: img.title
    });
    const url = img.image?.source?.url;

    getUrlImage(url, setAppImage);
  };

  useEffect(() => {
    return () => {
      setDetail('');
    };
  }, [setDetail]);

  return (
    <>
      <main className="card card-app-photos pd-3">
        <TextField
          id="search"
          label="Search"
          value={query}
          onChange={handleInputQuery}
          className="ml-2"
          autoComplete="off"
        />
        <ImagesContainer more={more}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="row">
              {images.map((img, index) => (
                <Image
                  key={index}
                  alt={img.author?.name || 'Unknown Author'}
                  src={img.image?.source?.url}
                  userPage={img.url}
                  selectImage={() => handleSelect(img)}
                />
              ))}
            </div>
          )}
        </ImagesContainer>
      </main>
      <DescriptionSection
        title={'Freepik Gallery Description'}
        detail={detail}
      />
    </>
  );
};

export default Freepik;
